import { createAction, props } from '@ngrx/store';
export const setTalkingPoints = createAction('[Custom PDF Report Modal] Set Talking Points', props());
